import { useState } from "react";
import { useSelector } from "react-redux";
import { Badge } from "react-bootstrap";
import { Translate } from "../../../Enums/Tranlate";
import trashIcon from "../../../../images/icons/delete.svg";
import DeleteModal from "../../../common/DeleteModal";
import UsersService from "../../../../services/UsersService";
import { toast } from "react-toastify";

const CardItem = ({ item, index, setShouldUpdate }) => {
	const lang = useSelector((state) => state.auth?.lang);
	const [deleteModal, setDeleteModal] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const [status, setStatus] = useState(!item?.isBlocked);
	const changeStatus = () => {
		let data = {
			isBlocked: !status,
		};
		new UsersService().toggleStatus(item?.id, data).then((res) => {
			if (res?.status) {
				toast.success("Status Updated Successfully");
				setStatus((prev) => !prev);
			}
		});
	};
	return (
		<tr key={index} className="text-center">
			<td>{item?.fullname || "-"}</td>
			<td>{item?.phone || "-"}</td>
			<td>{item?.email || "-"}</td>
			<td>
				<Badge
					className="cursor-pointer"
					onClick={changeStatus}
					variant={status ? "primary light" : "danger light"}>
					{Translate[lang][status ? "active" : "deactive"]}
				</Badge>
			</td>
			<td>
				{isExist("delete_users") && (
					<img
						src={trashIcon}
						onClick={() => setDeleteModal(true)}
						className="cursor-pointer"
						alt="trash"
						width={24}
					/>
				)}
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.fullname}
					deletedItem={item}
					modelService={new UsersService()}
					setShouldUpdate={setShouldUpdate}
					onCloseModal={setDeleteModal}
					isDeleted={true}
				/>
			)}
		</tr>
	);
};
export default CardItem;
